module.exports = __webpack_public_path__ + "media/images/highligts_image_2-e7b06a2157090e09516593cd087e0e16.png";